export const blockIconsTransportationDirectionsWalkNew = (
	<span className='material-symbols-outlined'>directions_walk</span>
);
